"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var react_1 = __importStar(require("react"));
var client_2 = __importDefault(require("react-dom/client"));
var react_i18next_1 = require("react-i18next");
var Spinner_1 = __importDefault(require("../common/Spinner/Spinner"));
var UmvaRouter_1 = __importDefault(require("../config/UmvaRouter"));
var apolloClient_1 = __importDefault(require("../config/apolloClient"));
var translation_1 = __importDefault(require("../translation/translation"));
var root = client_2.default.createRoot(document.getElementById('main'));
function Main() {
    return (react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Spinner_1.default, null) },
        react_1.default.createElement(client_1.ApolloProvider, { client: apolloClient_1.default },
            react_1.default.createElement(react_i18next_1.I18nextProvider, { i18n: translation_1.default },
                react_1.default.createElement(UmvaRouter_1.default, null)))));
}
root.render(react_1.default.createElement(react_1.default.StrictMode, null,
    react_1.default.createElement(Main, null)));
